import { render, staticRenderFns } from "./SelectQuestionBox.vue?vue&type=template&id=6c872008&scoped=true"
import script from "./SelectQuestionBox.ts?vue&type=script&lang=ts&external"
export * from "./SelectQuestionBox.ts?vue&type=script&lang=ts&external"
import style0 from "./SelectQuestionBox.vue?vue&type=style&index=0&id=6c872008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c872008",
  null
  
)

export default component.exports